import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-body',
  templateUrl: './modal-body.component.html'
})
export class ModalBodyComponent {
}